import { SessionLayer } from "../../interfaces";
import { getAppBFFUrl } from "../functions";
import { formatData, handleError, handleStepSuccessEvent } from "./api";

export const sendDigaRedeem = async (data: SessionLayer, requestConditions: any) => {
  const { lead_data, push_data, marketing_data } = data;
  const { is_last_step, hasSuccessStep, defaultSuccessPageUrl, successPageRules } = requestConditions;
  const formCompleted = is_last_step || hasSuccessStep;
  const formattedData = await formatData(lead_data, push_data, marketing_data, formCompleted, true);
  const baseUrl = await getAppBFFUrl();

  const requestBody = {
    product: String(formattedData.get("product")).toLowerCase(),
    email: formattedData.get("email"),
    diga_code: formattedData.get("diga_code")
  };

  try {
    const res = await fetch(
      `${baseUrl}/platform-nexus/public/v2/payments/diga-code-redeem/`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      },
    );
    await handleStepSuccessEvent(res, is_last_step, hasSuccessStep, defaultSuccessPageUrl, successPageRules);
    const responseData = await res.json();

    return {res, details: responseData?.detail}
  } catch (error) {
    handleError(error);
  }
}
